import { render, staticRenderFns } from "./maintenance.vue?vue&type=template&id=3963aea4&scoped=true"
import script from "./maintenance.vue?vue&type=script&lang=js"
export * from "./maintenance.vue?vue&type=script&lang=js"
import style0 from "./maintenance.vue?vue&type=style&index=0&id=3963aea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3963aea4",
  null
  
)

export default component.exports